import script from "./DeliveryLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryLocation.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryLocation.vue?vue&type=style&index=0&id=d8ca3e2e&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ca3e2e"]])

export default __exports__